import { useObserver } from 'mobx-react';

/* Hooks */
import { useStore } from '~/src/hooks/useMst';
import useFeatureFlags from '~/src/hooks/useFeatureFlags';

export const useClio = () => {
  const { clio } = useStore();
  return useObserver(() => ({
    isAuthenticated: clio.authenticated,
  }));
};

export const useIsClioAuthenticated = () => useClio().isAuthenticated;

export const useCanSyncSingleMatter = () => {
  const isClioAuthenticted = useIsClioAuthenticated();
  const isUnifiedPlatform = useFeatureFlags().isUnifiedPlatform;
  return isClioAuthenticted && isUnifiedPlatform;
};

export default useClio;
